<template>
  <div class="linii-wrapper">
    <DxDataGrid :ref="liniiDataGrid" :allow-column-reordering="true" :data-source="dsLiniiDocumente" :allow-column-resizing="true" :column-auto-width="false"
    :column-min-width="50" :column-resizing-mode="'nextColumn'" :show-borders="true" :sync-lookup-filter-values="false" :filter-sync-enabled="true"
    :show-column-lines="false" :show-row-lines="true" :row-alternation-enabled="true" :hover-state-enabled="true"
    height="100%" class="linii-grid"
    @row-dbl-click="onRowDblClick" @exporting="onExporting">
        <DxExport :enabled="true" :formats="['xlsx']" :load-panel="{ enabled: true, showIndicator: true, text: 'Loading...' }"/>
        <DxFilterRow :visible="true"/>
        <DxGrouping :context-menu-enabled="true">
            <DxTexts
                group-continued-message="Continuat de pe pagina anterioara"
                group-continues-message="Continuat pe pagina urmatoare"
            />
        </DxGrouping>
        <DxGroupPanel :visible="true" emptyPanelText="Trage aici o coloana pentru a grupa datele" />
        <DxLoadPanel :enabled="true" text="Loading..." :indicator-src="'reload6.gif'" />
        <DxSorting mode="multiple" />
        <DxStateStoring :enabled="true" :filterValue="false" storage-key="dsLiniiDocumente-v2" />
        <DxColumnChooser :enabled="true" mode="select" title="Selector coloane" :allowSearch="true" sortOrder="asc" />
        <DxPaging :page-size="10" />
        <DxPager :show-page-size-selector="true" :allowed-page-sizes="[5, 10, 20]" :show-info="true"
            :show-navigation-buttons="true" />

        <DxToolbar>
            <DxItem location="before" template="filterToggleTemplate" />
            <DxItem location="before" template="periodToggleTemplate" />
            <DxItem name="exportButton" />
            <DxItem name="columnChooserButton" />
        </DxToolbar>

        <!-- Buton Deschide Document (fix la început, ca la Documente) -->
        <DxColumn caption="" width="50" :fixed="true" fixed-position="left" :allow-sorting="false" :allow-filtering="false"
            :allow-resizing="true" :allow-reordering="false" cell-template="deschideCellTemplate" />
        <!-- Buton Tipărire document (ca la Comenzi) -->
        <DxColumn caption="" width="50" :fixed="true" fixed-position="left" :allow-sorting="false" :allow-filtering="false"
            :allow-resizing="true" :allow-reordering="false" cell-template="tipareseCellTemplate" />

        <DxColumn data-field="Numar" caption="Numar document" />
        <DxColumn data-field="Categorie" caption="Categorie document" />
        <DxColumn data-field="Tip" caption="Tip document" />
        <DxColumn data-field="Data" caption="Data contabilă" data-type="date" format="yyyy-MM-dd" />
        <DxColumn data-field="Partener" caption="Partener" />
        <DxColumn data-field="Produs" caption="Produs" />
        <DxColumn data-field="Unitate" caption="Unitate" />
        <DxColumn data-field="Cantitate" caption="Cantitate" data-type="number" format="#,##0.00" />
        <DxColumn data-field="PretUnitar" caption="Pret unitar" data-type="number" format="#,##0.0000" :allowSearch="false" />
        <DxColumn data-field="Total" caption="Total" data-type="number" format="#,##0.00" :allowSearch="false" />
        <DxColumn data-field="Valuta" caption="Valuta" />

        <DxColumn caption="Context document">
            <DxColumn data-field="ContractNumar" caption="Numar contract" :visible="false" />
            <DxColumn data-field="Proiect" caption="Proiect" :visible="false" />
            <DxColumn data-field="Comanda" caption="Comanda" :visible="false" />
            <DxColumn data-field="Zona" caption="Zona" :visible="false" />
            <DxColumn data-field="AgentNume" caption="Agent" :visible="false" />
            <DxColumn data-field="DataDoc" caption="Data document" :visible="false" data-type="date" format="yyyy-MM-dd" />
            <DxColumn data-field="Scadenta" caption="Data scadenta" :visible="false" data-type="date" format="yyyy-MM-dd" />
        </DxColumn>

        <DxColumn caption="Rezumat financiar">
            <DxColumn data-field="Valoare" caption="Valoare" :visible="false" data-type="number" format="#,##0.00" :allowSearch="false" />
            <DxColumn data-field="ValoareTva" caption="Valoare TVA" :visible="false" data-type="number" format="#,##0.00" :allowSearch="false" />
            <DxColumn data-field="Tva" caption="TVA %" :visible="false" data-type="number" format="#,##0.00" :allowSearch="false" />
            <DxColumn data-field="Tvaunitar" caption="TVA unitar" :visible="false" data-type="number" format="#,##0.0000" :allowSearch="false" />
            <DxColumn data-field="PretTotal" caption="Pret total" :visible="false" data-type="number" format="#,##0.00" :allowSearch="false" />
            <DxColumn data-field="Pret" caption="Pret" :visible="false" data-type="number" format="#,##0.00" :allowSearch="false" />
            <DxColumn data-field="ValoarePret" caption="Valoare pret" :visible="false" data-type="number" format="#,##0.00" :allowSearch="false" />
            <DxColumn data-field="AdaosUnitar" caption="Adaos unitar" :visible="false" data-type="number" format="#,##0.00" :allowSearch="false" />
            <DxColumn data-field="ValoareAdaos" caption="Valoare adaos" :visible="false" data-type="number" format="#,##0.00" :allowSearch="false" />
            <DxColumn data-field="Adaos" caption="Adaos" :visible="false" data-type="number" format="#,##0.00" :allowSearch="false" />
            <DxColumn data-field="PretCuAdaos" caption="Pret cu adaos" :visible="false" data-type="number" format="#,##0.00" :allowSearch="false" />
            <DxColumn data-field="ValoareCuAdaos" caption="Valoare cu adaos" :visible="false" data-type="number" format="#,##0.00" :allowSearch="false" />
        </DxColumn>

        <DxColumn data-field="Lot" caption="Lot" :visible="false" />
        <DxColumn data-field="CodLotIntern" caption="Cod lot intern" :visible="false" />
        <DxColumn data-field="CodLotFurnizor" caption="Cod lot furnizor" :visible="false" />
        <DxColumn data-field="DataExp" caption="Data expirare" :visible="false" data-type="date" format="yyyy-MM-dd" />
        <DxColumn data-field="LotData" caption="Data lot" :visible="false" data-type="date" format="yyyy-MM-dd" />
        <DxColumn data-field="LotFixat" caption="Lot fixat?" :visible="false" cell-template="circleTemplate" :allowSearch="false" />
        <DxColumn data-field="Intrari" caption="Intrari" :visible="false" data-type="number" :allowSearch="false" />
        <DxColumn data-field="Iesiri" caption="Iesiri" :visible="false" data-type="number" :allowSearch="false" />
        <DxColumn data-field="LocDepozitare" caption="Loc depozitare" :visible="false" />
        <DxColumn data-field="GarantieLuni" caption="Garantie luni" :visible="false" data-type="number" :allowSearch="false" />

        <DxColumn data-field="DataCreare" caption="Data creare" :visible="false" data-type="date" format="yyyy-MM-dd" />
        <DxColumn data-field="DataModificare" caption="Data modificare" :visible="false" data-type="date" format="yyyy-MM-dd" />
        <DxColumn data-field="UserCreare" caption="User creare" :visible="false" :allowSearch="false" />
        <DxColumn data-field="UserModificare" caption="User modificare" :visible="false" :allowSearch="false" />

        <template #circleTemplate="{ data }">
            <div class="circle-container">
                <div v-if="data.value" class="circle circle-true">✔</div>
                <div v-else class="circle circle-false"></div>
            </div>
        </template>

        <template #deschideCellTemplate="{ data }">
            <DxButton icon="eyeopen" hint="Deschide Document" type="default" styling-mode="outlined"
                class="deschide-btn" @click="() => openDocument(data.data)" />
        </template>

        <template #tipareseCellTemplate="{ data }">
            <DxButton icon="print" hint="Tipărește document" type="default" styling-mode="outlined"
                class="deschide-btn" :disabled="isPrinting" @click="() => onTipareseDocument(data.data)" />
        </template>

        <template #filterToggleTemplate>
            <DxButton
                icon="filter"
                text="Filtre"
                styling-mode="contained"
                class="filter-toggle-btn"
                @click="$emit('toggle-filters')"
            />
        </template>

        <template #periodToggleTemplate>
            <DxButton
                icon="event"
                text="Perioadă"
                styling-mode="contained"
                class="filter-toggle-btn"
                @click="$emit('toggle-filters', 'date')"
            />
        </template>

    </DxDataGrid>

    <DxPopup :visible="isPdfPreviewVisible" :width="1000" :height="800" :drag-enabled="true"
        :resize-enabled="true" :hide-on-outside-click="true" @update:visible="v => { if (!v) closePdfPreview(); }">
        <template #title>
            <div style="background-color: #ff2c21; font-size: 15px; color: white; font-weight: bold; padding: 10px; padding-left: 20px;">
                {{ pdfFileName || 'Previzualizare document' }}
            </div>
        </template>
        <div style="display:flex; flex-direction:column; height:100%;">
            <div style="flex:1; border-top:1px solid #ddd;">
                <iframe v-if="pdfBlobUrl" :src="pdfPreviewSrc" style="width:100%; height:100%; border:0;" />
            </div>
            <div style="display:flex; justify-content:center; align-items:center; gap:16px; padding:12px;">
                <DxButton text="Descarcă PDF" icon="download" type="success" @click="downloadPreviewReport" />
                <DxButton text="Închide" type="danger" icon="close" @click="closePdfPreview" />
            </div>
        </div>
    </DxPopup>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import {
  DxColumn,
  DxColumnChooser,
  DxDataGrid,
  DxExport,
  DxFilterRow,
  DxGrouping,
  DxGroupPanel,
  DxLoadPanel,
  DxPager,
  DxPaging,
  DxSorting,
  DxStateStoring,
  DxTexts,
  DxToolbar,
  DxItem
} from 'devextreme-vue/data-grid';
import { DxButton } from 'devextreme-vue/button';
import { DxPopup } from 'devextreme-vue/popup';
import DataSource from 'devextreme/data/data_source';
import AppSetting from '@/settings/appSettings';
import http from '@/settings/apiSettings';
import notify from 'devextreme/ui/notify';
import { usePrintReport } from '@/composable/usePrintReport';
import { exportDataGrid as exportDataGridExcel } from 'devextreme/excel_exporter';
import { Workbook } from 'exceljs';
import { saveAs } from 'file-saver';

export default defineComponent({
    name: 'LiniiDocumenteView',
    setup() {
        const {
            isPrinting, previewReport,
            pdfBlobUrl, pdfPreviewSrc, pdfFileName, isPdfPreviewVisible,
            downloadPreviewReport, closePdfPreview,
        } = usePrintReport();
        return {
            isPrinting, previewReport,
            pdfBlobUrl, pdfPreviewSrc, pdfFileName, isPdfPreviewVisible,
            downloadPreviewReport, closePdfPreview,
        };
    },
    components: {
        DxDataGrid,
        DxColumn,
        DxSorting,
        DxFilterRow,
        DxStateStoring,
        DxColumnChooser,
        DxLoadPanel,
        DxPager,
        DxPaging,
        DxGrouping,
        DxGroupPanel,
        DxTexts,
        DxExport,
        DxToolbar,
        DxItem,
        DxButton,
        DxPopup
    },
    props: {
        initialFilters: {
            type: Object,
            default: null
        }
    },
    data() {
        return {
            dsLiniiDocumente: null as any,
            liniiDataGrid: 'liniiDataGrid',
            externalFilters: null as any
        };
    },
    mounted() {
        this.dsLiniiDocumente = this.createLiniiDataSource();
    },
    watch: {
        initialFilters: {
            handler(newVal) {
                this.loadData(newVal)
            },
            immediate: true
        }
    },
    methods: {
        createLiniiDataSource() {
            return new DataSource({
                store: {
                    type: 'odata',
                    url: AppSetting.API_Url_DocumenteOdata + 'DOC_CautareLinii',
                    key: 'Id',
                    keyType: 'Guid',
                    version: 4,
                    fieldTypes: {
                        TipId: 'Guid',
                        CategorieId: 'Guid',
                        GrupPartenerID: 'Guid',
                        ZonaID: 'Guid',
                        PartenerID: 'Guid',
                        ProiectID: 'Guid',
                        ComandaID: 'Guid',
                        AgentID: 'Guid',
                    },
                    beforeSend: (e: any) => {
                        e.headers = {
                            'Content-Type': 'application/json',
                            'Authorization': 'Bearer ' + (localStorage.getItem('ERA_Jwt') ?? '')
                        };
                    }
                }
            });
        },
        ensureLiniiDataSource() {
            if (!this.dsLiniiDocumente) {
                this.dsLiniiDocumente = this.createLiniiDataSource()
            }
        },
        loadData(params: any) {
            this.externalFilters = params
            this.ensureLiniiDataSource()
            const rawFilters = Array.isArray(this.externalFilters?.filters) && this.externalFilters.filters.length > 0 ? this.externalFilters.filters : null

            this.dsLiniiDocumente.filter(rawFilters)

            return this.dsLiniiDocumente.reload()
        },
        refreshData() {
            return this.loadData(this.externalFilters)
        },
        onRowDblClick(e: any) {
            if (e.data) {
                this.openDocument(e.data)
            }
        },
        openDocument(data: any) {
            this.$emit('open-document', {
                Id: data.DocumentId,
                Numar: data.Numar,
                Tip: data.Tip,
                Data: data.Data,
                Partener: data.Partener
            })
        },
        onExporting(e: any) {
            const workbook = new Workbook();
            const worksheet = workbook.addWorksheet('Linii documente');

            exportDataGridExcel({
                component: e.component,
                worksheet,
                autoFilterEnabled: true,
            }).then(() => {
                workbook.xlsx.writeBuffer().then((buffer: any) => {
                    saveAs(new Blob([buffer], { type: 'application/octet-stream' }), 'LiniiDocumente.xlsx');
                });
            });
            e.cancel = true;
        },
        urlRaport(clasaRaport: string, documentID: string): string {
            const params = new URLSearchParams({ clasaRaport, documentID });
            return `${AppSetting.API_Url_Rapoarte}report/GetReportByClasaRaport?${params}`;
        },
        async onTipareseDocument(rowData: any) {
            const tipId = rowData.TipId;
            if (!tipId) {
                notify('Documentul nu are un tip asociat — nu se poate genera raportul.', 'warning', 3000);
                return;
            }
            try {
                const tipResp = await http.clientDocumenteOdata.get(
                    `DOC_Tipuri(${tipId})?$select=ClasaRaport,ClasaRaport2,TitluRaport`
                );
                const tip = tipResp.data;
                const clasaRaport = tip?.ClasaRaport || tip?.ClasaRaport2;
                if (!clasaRaport) {
                    notify('Tipul documentului nu are un raport configurat (ClasaRaport lipsă).', 'warning', 3000);
                    return;
                }
                const token = localStorage.getItem('ERA_Jwt') ?? '';
                const fileName = `${tip?.TitluRaport || rowData.Tip || 'Document'}_${rowData.Numar ?? ''}`
                    .replace(/[\\/:*?"<>|]/g, '-').trim() + '.pdf';
                const ok = await this.previewReport(this.urlRaport(clasaRaport, rowData.DocumentId), token, fileName);
                if (!ok) notify('Raportul nu a putut fi generat.', 'error', 3000);
            } catch (error) {
                console.error('Eroare la generarea raportului:', error);
                notify('Eroare la generarea raportului.', 'error', 4000);
            }
        }
    }
});
</script>

<style scoped>
.linii-wrapper {
  flex: 1;
  min-height: 0;
  width: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  background: #f8f9fc;
}

.linii-grid {
  flex: 1;
  min-height: 0;
  margin: 12px;
  border-radius: 8px;
  overflow: hidden;
}

.linii-wrapper :deep(.dx-scrollable-scroll-content) {
  background-color: #ff6a4a !important;
  border-radius: 6px !important;
}

.linii-wrapper :deep(.dx-scrollbar-vertical),
.linii-wrapper :deep(.dx-scrollbar-horizontal) {
  background-color: #ffe4dc !important;
}

.linii-wrapper :deep(.dx-toolbar) {
  height: 32px !important;
}

.linii-wrapper :deep(.dx-toolbar-items-container) {
  height: 32px !important;
}

.linii-wrapper :deep(.dx-datagrid-filter-row .dx-texteditor) {
  height: 26px !important;
}

.linii-wrapper :deep(.dx-datagrid-filter-row .dx-texteditor-input) {
  height: 26px !important;
  min-height: unset !important;
}

.linii-wrapper :deep(.dx-row > td) {
  padding-top: 0 !important;
  padding-bottom: 0 !important;
  font-size: 11px !important;
  line-height: 1.1 !important;
}

.linii-wrapper :deep(.dx-datagrid-headers .dx-header-row td) {
  height: 24px !important;
}

.linii-wrapper :deep(.dx-datagrid-rowsview .dx-row) {
  height: 26px !important;
}

.linii-search-container {
  height: 100%;
  padding: 10px;
}

.linii-wrapper :deep(.deschide-btn) {
  height: 26px !important;
  width: 26px !important;
  min-width: unset !important;
  line-height: 26px !important;
}

.linii-wrapper :deep(.deschide-btn .dx-icon) {
  font-size: 16px !important;
  line-height: 26px !important;
}

.circle-container {
  display: flex;
  justify-content: center;
  align-items: center;
}

.circle {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  font-size: 14px;
  line-height: 20px;
  text-align: center;
}

.circle-true {
  background-color: #4caf50;
  color: white;
}

.circle-false {
  border: 2px solid #aaa;
}
</style>

<style>
.filter-toggle-btn {
  background-color: white !important;
  border-radius: 8px !important;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1) !important;
  color: #475569 !important;
  height: 28px !important;
  font-size: 12px !important;
  margin-right: 8px;
  transition: all 0.2s ease !important;
}

.filter-toggle-btn .dx-icon {
  font-size: 14px !important;
}

.filter-toggle-btn:hover {
  color: #ff2c21 !important;
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15) !important;
}
</style>
